import { Elements } from '@stripe/react-stripe-js';
import React from 'react';
import { LoadingIndicator } from 'src/latest/src';
import StripeCard from './StripeCard/StripeCard';
import { Stripe } from '@stripe/stripe-js';
import { address, SetupIntentResponse } from '../StripePaymentInterface';
import { useTranslation } from 'react-i18next';
import { User } from 'src/latest/src/components/UserProfileHeader/types';

interface StripeAddProps {
  setupIntent: SetupIntentResponse | null;
  stripePromise: Promise<Stripe | null> | null;
  onToken?: (status: string, choice: any) => void;
  choice: any;
  handleCardUpdated: () => void;
  accountAddress: address;
  responsiblePartyAccountAddress: any;
  fromOnboarding: boolean;
  userData: User | null;
  handleLeftArrowClick: () => void;
  hideBackButton: boolean;
  isDirectoryPlatform: boolean;
  onFormValidationChange?: (isValid: boolean) => void;
  stripeCardRef?: any;
  onStripeProcessingChange?: (isProcessing: boolean) => void;
}

const StripeAdd: React.FC<StripeAddProps> = ({
  setupIntent,
  stripePromise,
  onToken,
  choice,
  handleCardUpdated,
  accountAddress,
  responsiblePartyAccountAddress,
  fromOnboarding,
  userData,
  handleLeftArrowClick,
  hideBackButton,
  isDirectoryPlatform,
  onFormValidationChange,
  stripeCardRef,
  onStripeProcessingChange,
}) => {
  const { t } = useTranslation('stripePayment');

  return (
    <>
      {setupIntent && stripePromise ? (
        <div>
          <Elements
            stripe={stripePromise}
            options={{
              clientSecret: setupIntent.client_secret,
              appearance: {
                theme: 'stripe',
                variables: {
                  colorPrimary: '#6366f1',
                },
              },
            }}
          >
            <StripeCard
              ref={stripeCardRef}
              clientSecret={setupIntent.client_secret}
              clientPaymentProfileId={setupIntent.client_payment_profile_id}
              onToken={onToken}
              choice={choice}
              buttonLabel={t('stripeAdd.buttonLabel.add')}
              onCardUpdated={handleCardUpdated}
              fromAddScreen={true}
              accountAddress={accountAddress}
              responsiblePartyAccountAddress={responsiblePartyAccountAddress}
              fromOnboarding={fromOnboarding}
              userData={userData}
              handleLeftArrowClick={handleLeftArrowClick}
              hideBackButton={hideBackButton}
              isDirectoryPlatform={isDirectoryPlatform}
              onFormValidationChange={onFormValidationChange}
              onProcessingChange={onStripeProcessingChange}
            />
          </Elements>
        </div>
      ) : (
        <LoadingIndicator loading={true} />
      )}
    </>
  );
};

export default StripeAdd;
